import { getEntryDraftKey } from './getEntryDraftKey';
import { useEntryDraftState } from './useEntryDraftState';
import { useActiveProfile } from '@/store/localStorage/useTokenState';

export function setEntryDraft(entryData, blog, activeProfileId) {
  return (draft) => {
    const entryId = getEntryDraftKey(entryData.id, blog);

    if (
      !entryData.content &&
      !entryData.title &&
      (!entryData.tags || entryData.tags.length === 0)
    ) {
      if (draft?.[activeProfileId]?.[entryId]) {
        delete draft[activeProfileId][entryId];
      }
      return draft;
    } else {
      return {
        ...draft,
        [activeProfileId]: {
          ...draft?.[activeProfileId],
          [entryId]: {
            ...draft?.[activeProfileId]?.[entryId],
            ...entryData
          }
        }
      };
    }
  };
}

export function useSetEntryDraft() {
  const [, setDraft] = useEntryDraftState();
  const { activeProfileId } = useActiveProfile();

  return (entryData, blog) =>
    setDraft(setEntryDraft(entryData, blog, activeProfileId));
}
